/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import Context from "../../scripts/context/User";
import axios from "axios";
import {
  Navigate,
  Outlet,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Avatar, IconButton, Tooltip } from "@mui/material";

// constants
import { STEPS, STEPS_DATA } from "./constants";
import DropMenu from "../../components/Navbar/DropMenu";
import { WalletContext } from "../../scripts/context/WalletContext";

export default function RegisterPage() {
  const navigate = useNavigate();
  const { web3 } = useContext(WalletContext);
  const { stopPresale } = web3.contracts.presale.data;
  const { globalState, getRegistrationStep } = useContext(Context);
  const [activeStep, setActiveStep] = useState(globalState.registration_step);
  const [data, setData] = useState(STEPS_DATA);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    PersonalInformation: "",
    UploadKYC: "",
    LinkWallet: "",
  });
  const [accountStatus, setAccountStatus] = useState("");
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setData({
      ...data,
      personalInformation: {
        ...data.personalInformation,
        invitation_code: searchParams.get("invitation_code"),
      },
    });
  }, []);

  const handleClick = (index) => {
    if ([1, 2].includes(index) && globalState.registration_step >= 3) return;
    if (index === 1 && globalState.registration_step >= 2) return;

    setActiveStep(
      globalState.registration_step >= index
        ? index
        : globalState.registration_step
    );
  };
  const handleBack = () => {
    if (activeStep === 3) {
      setActiveStep(0);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };
  const handleNext = () => {
    if (errors.PersonalInformation && errors.UploadKYC) return setActiveStep(3);
    if (errors.PersonalInformation) return setActiveStep(5);
    if (errors.UploadKYC) return setActiveStep(5);

    if (activeStep === 0 && globalState.registration_step >= 3) {
      setActiveStep(globalState.registration_step);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };
  const activeData = Object.values(data)[activeStep];
  const setActiveData = (newData) => {
    setData({
      ...data,
      [Object.keys(data)[activeStep]]: newData,
    });
  };
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);

  useEffect(() => {
    globalState.registration_step === -1 && navigate(globalState.redirect_uri);

    if (globalState.registration_step === 5) {
      setLoading(true);
      axios
        .get("/register/account_status/getAccountSummary")
        .then(({ data: apiData }) => {
          setAccountStatus(apiData.account_status);
          if (apiData.data.KYC.values.document_type === "pdf") {
            axios
              .get(apiData.data.KYC.values.document, {
                responseType: "blob",
              })
              .then((response) => {
                const fileURL = window.URL.createObjectURL(
                  new Blob([response.data], { type: "application/pdf" })
                );
                setData({
                  ...data,
                  personalInformation: apiData.data.personal_info.values,
                  linkWallet: apiData.data.wallet_address.values,
                  uploadKYC: {
                    kyc_file: fileURL,
                    type: "pdf",
                  },
                });
                setErrors({
                  PersonalInformation: apiData.data.personal_info.error_message,
                  UploadKYC: apiData.data.KYC.error_message,
                  LinkWallet: apiData.data.wallet_address.error_message,
                });
                setLoading(false);
              })
              .catch(() => {
                setLoading(false);
              });
          } else {
            setData({
              ...data,
              personalInformation: apiData.data.personal_info.values,
              linkWallet: apiData.data.wallet_address.values,
              uploadKYC: {
                kyc_file: apiData.data.KYC.values.document,
                type: "image",
              },
            });
            setErrors({
              PersonalInformation: apiData.data.personal_info.error_message,
              UploadKYC: apiData.data.KYC.error_message,
              LinkWallet: apiData.data.wallet_address.error_message,
            });
            setLoading(false);
          }
        });
    }
  }, [globalState.registration_step]);

  useEffect(() => navigate(globalState.redirect_uri), []);
  useEffect(() => navigate(STEPS[activeStep]?.path), [activeStep, navigate]);

  const isStepFailed = (step) => {
    return errors[step];
  };

  if (stopPresale && !localStorage.token)
    return <Navigate to="/login" />;

  if (globalState.user?.status === "Active")
    return <Navigate to={globalState.redirect_uri} />;

  return (
    <div className="d-flex flex-column flex-root">
      <div
        className="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid wizard"
        id="kt_login"
      >
        <div className="login-aside d-flex flex-column flex-row-auto">
          <div className="d-flex flex-column-auto flex-column py-15 px-15 position-sticky top-0">
            <div className="d-flex align-items-center justify-content-between">
              <img
                src="/img/logo.svg"
                className="h-40px user-select-none"
                alt="brand"
              />
              {globalState.user && (
                <>
                  <Tooltip title="Open settings">
                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                      <Avatar
                        alt={globalState.user.full_name}
                        src={globalState.user.avatar}
                      />
                    </IconButton>
                  </Tooltip>
                  <DropMenu
                    anchorElUser={anchorElUser}
                    setAnchorElUser={setAnchorElUser}
                  />
                </>
              )}
            </div>
            <div className="wizard-nav pt-5 pt-lg-15">
              <div className="wizard-steps">
                {STEPS.map((step, index) => (
                  <div
                    className="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state={
                      activeStep === index
                        ? "current"
                        : globalState.registration_step > index ||
                          activeStep > index
                        ? "done"
                        : ""
                    }
                    onClick={() =>
                      !stopPresale &&
                      accountStatus !== "Pending" &&
                      handleClick(index)
                    }
                  >
                    <div
                      className="wizard-wrapper"
                      style={{
                        cursor: stopPresale
                          ? "default"
                          : accountStatus === "Pending"
                          ? "default"
                          : "pointer",
                      }}
                    >
                      <div
                        className="wizard-icon"
                        style={{
                          backgroundColor: isStepFailed(step.key)
                            ? "#f6baba"
                            : step.key === "CaseStatus" &&
                              accountStatus === "Pending"
                            ? "#413e2d"
                            : "",
                          border:
                            step.key === "CaseStatus" &&
                            accountStatus === "Pending"
                              ? "2px solid #FFA800"
                              : "",
                        }}
                      >
                        {isStepFailed(step.key) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                            className="mt-n1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <rect x="0" y="0" width="24" height="24"></rect>
                              <path
                                d="M11.1669899,4.49941818 L2.82535718,19.5143571 C2.557144,19.9971408 2.7310878,20.6059441 3.21387153,20.8741573 C3.36242953,20.9566895 3.52957021,21 3.69951446,21 L21.2169432,21 C21.7692279,21 22.2169432,20.5522847 22.2169432,20 C22.2169432,19.8159952 22.1661743,19.6355579 22.070225,19.47855 L12.894429,4.4636111 C12.6064401,3.99235656 11.9909517,3.84379039 11.5196972,4.13177928 C11.3723594,4.22181902 11.2508468,4.34847583 11.1669899,4.49941818 Z"
                                fill="red"
                                opacity="0.3"
                              ></path>
                              <rect
                                fill="red"
                                x="11"
                                y="9"
                                width="2"
                                height="7"
                                rx="1"
                              ></rect>
                              <rect
                                fill="red"
                                x="11"
                                y="17"
                                width="2"
                                height="2"
                                rx="1"
                              ></rect>
                            </g>
                          </svg>
                        ) : (
                          <i className="wizard-check">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              version="1.1"
                            >
                              <g
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <polygon points="0 0 24 0 24 24 0 24" />
                                <path
                                  d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                                  fill="#000000"
                                  fill-rule="nonzero"
                                  transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                                />
                              </g>
                            </svg>
                          </i>
                        )}

                        {!Boolean(isStepFailed(step.key)) && (
                          <span className="wizard-number d-flex">
                            {step.key === "CaseStatus" &&
                            accountStatus === "Pending" ? (
                              <svg
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.6391 16.6847L13.1134 14.1589C12.7209 13.7666 12.5004 13.2344 12.5002 12.6794V6.22168"
                                  stroke="#FFA800"
                                  stroke-width="1.76923"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            ) : (
                              (globalState.registration_step <= index ||
                                activeStep === index) &&
                              index + 1
                            )}
                          </span>
                        )}
                      </div>
                      <div className="wizard-label">
                        <h3 className="wizard-title">{step.label}</h3>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="font-size-h6 font-weight-bolder text-white pt-10">
              <span>
                If you need any assistance,
                <br />
                please feel free to drop by our
              </span>{" "}
              <a
                href="https://t.me/bullitapp_discussion"
                target="_blank"
                rel="noreferrer"
                className="text-primary"
              >
                Telegram group
              </a>
            </div>
          </div>
        </div>
        <div className="login-content flex-column-fluid d-flex flex-column p-10">
          <div className="d-flex flex-row-fluid flex-center">
            <div className="login-form login-form-signup">
              {stopPresale ? (
                <div className="pt-lg-0 pt-5">
                  <h3 className="font-weight-bolder text-white font-size-h2 font-size-h1-lg">
                    Presale is over
                  </h3>
                  <div className="text-muted font-weight-bold font-size-h4 my-10">
                    You cannot complete your registration because presale stage
                    was over
                  </div>
                </div>
              ) : (
                <Outlet
                  context={{
                    handleNext,
                    allData: data,
                    setAllData: setData,
                    data: activeData,
                    setData: setActiveData,
                    loading,
                    setLoading,
                    activeStep,
                    setActiveStep,
                    getRegistrationStep,
                    errorsFromAPI: errors[STEPS[activeStep]?.key],
                    setErrorsFromAPI: (newErrors) => {
                      setErrors({
                        ...errors,
                        [STEPS[activeStep].key]: newErrors,
                      });
                    },
                    setAccountStatus,
                    accountStatus,
                    allErrors: errors,
                    setAllErrors: setErrors,
                    handleClick,
                  }}
                />
              )}
              {accountStatus !== "Pending" && (
                <div className="d-flex justify-content-between pt-3 align-items-center">
                  <div className="mr-2">
                    <button
                      type="button"
                      className="btn btn-pill btn-outline-white font-weight-bold opacity-90 px-md-15 py-3"
                      disabled={
                        stopPresale ||
                        activeStep === 0 ||
                        loading ||
                        accountStatus === "Pending"
                      }
                      onClick={handleBack}
                    >
                      <span className="svg-icon svg-icon-md mr-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <polygon points="0 0 24 0 24 24 0 24" />
                            <rect
                              fill="#000000"
                              opacity="0.3"
                              transform="translate(15.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -12.000000) "
                              x="14"
                              y="7"
                              width="2"
                              height="10"
                              rx="1"
                            />
                            <path
                              d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                              transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997) "
                            />
                          </g>
                        </svg>
                      </span>
                      Previous
                    </button>
                  </div>
                  <div>
                    {activeStep === STEPS.length - 1 ? (
                      <button
                        type="submit"
                        className="btn btn-pill btn-white font-weight-bold px-md-15 py-3 just-white"
                        id="kt_login_signup_form_submit_button"
                        form="CaseStatus"
                        disabled={
                          stopPresale || loading || accountStatus === "Pending"
                        }
                      >
                        {accountStatus === "Rejected" &&
                        (errors.PersonalInformation || errors.UploadKYC)
                          ? "Show"
                          : "Submit"}
                        <span className="svg-icon svg-icon-md ml-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <rect
                                fill="#000000"
                                opacity="0.3"
                                transform="translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000) "
                                x="7.5"
                                y="7.5"
                                width="2"
                                height="9"
                                rx="1"
                              />
                              <path
                                d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997) "
                              />
                            </g>
                          </svg>
                        </span>
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-pill btn-white font-weight-bold px-md-15 py-3 just-white"
                        data-wizard-type="action-next"
                        form={STEPS[activeStep]?.key}
                        disabled={
                          stopPresale || loading || accountStatus === "Pending"
                        }
                      >
                        Next Step
                        <span className="svg-icon svg-icon-md ml-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <rect
                                fill="#000000"
                                opacity="0.3"
                                transform="translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000) "
                                x="7.5"
                                y="7.5"
                                width="2"
                                height="9"
                                rx="1"
                              />
                              <path
                                d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997) "
                              />
                            </g>
                          </svg>
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
